import { http } from './index';

/**
 * 高报项目查询相关接口
 */

/**
 * 根据订单号查询学员信息
 * 对应后端接口: POST /api/v1/web/member/student-info-by-order
 * @param orderNo 订单号
 */
export const getStudentInfoByOrder = (orderNo: string) => {
  return http.post('/eds-deliver/api/v1/web/member/student-info-by-order', { orderNo });
};

/**
 * 查询学员排班列表
 * 对应后端接口: POST /api/v1/private-booking/appointments
 * @param params 查询参数
 */
export const getGaobaoScheduleList = (params: {
  pageNum: number;
  pageSize: number;
  status?: number;
  startTime: string;
  endTime: string;
}) => {
  return http.post('/teaching-workbench/api/v1/private-booking/appointments', params);
};

/**
 * 预约提交
 * 对应后端接口: POST /api/v1/private-booking/appointment
 * @param params 预约参数
 */
export const submitAppointment = (params: {
  orderNo: string;
  startTime: string;
  endTime: string;
}) => {
  return http.post('/teaching-workbench/api/v1/private-booking/appointment', params);
};

/**
 * 取消预约
 * 对应后端接口: POST /booking/teacher/cancel
 * @param params 取消预约参数
 */
export const cancelAppointment = (params: {
  bookingId: number;
  reasonType?: number;
  reasonStr?: string;
}) => {
  return http.post('/teaching-workbench/booking/teacher/cancel', {
    reasonType: params.reasonType || 5,
    reasonStr: params.reasonStr || '高报取消',
    ...params,
  });
};
